export const API_URL = "https://5f83e2936b97440016f4eb8f.mockapi.io/"

export const SET_CURRENT_USER_REQUEST = "SET_CURRENT_USER_REQUEST"
export const SET_CURRENT_USER_SUCCESS = "SET_CURRENT_USER_SUCCESS"
export const SET_CURRENT_USER_FAILURE = "SET_CURRENT_USER_FAILURE"

export const GET_PRODUCT_DETAIL_SUCCESS = "GET_PRODUCT_DETAIL_SUCCESS"
export const GET_ALL_PRODUCT_SUCCESS = "GET_ALL_PRODUCT_SUCCESS"
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS"
export const FILTER_VALUE = "FILTER_VALUE"
export const SORT_PRODUCTS = "SORT_PRODUCTS"

export const NEXT_PAGE = "NEXT_PAGE"
export const PREV_PAGE = "PREV_PAGE"
export const LOAD_NEW_PAGE = "LOAD_NEW_PAGE"
export const LOAD_EXACT_PAGE = "LOAD_EXACT_PAGE"
export const LOAD_DATA = "LOAD_DATA"


export const GET_ALL_BLOG = "GET_ALL_BLOG"
export const GET_BLOG_DETAIL = "GET_BLOG_DETAIL"
export const ADD_BLOG = "ADD_BLOG"
export const EDIT_BLOG = "EDIT_BLOG"
export const DELETE_BLOG = "DELETE_BLOG"

export const GET_ALL_COMMENT = "GET_ALL_COMMENT"
export const REPLY_COMMENT_USER = "REPLY_COMMENT_USER"
export const DELETE_COMMENT = "DELETE_COMMENT"

export const GET_ALL_CONTACT = "GET_ALL_CONTACT"

export const GET_ALL_ORDER = "GET_ALL_ORDER"
export const GET_ORDER_DETAIL = "GET_ORDER_DETAIL"
export const CHANGE_STATUS_ORDER = "CHANGE_STATUS_ORDER"

export const SET_LOGOUT = "SET_LOGOUT"

export const SHOW_MODAL = "SHOW_MODAL"
export const HIDE_MODAL = "HIDE_MODAL"